<template>
    <div class="module-header" role="tab">
        <button class="btn btn-light d-flex justify-content-between align-items-center" @click="toggleAccordion">
            <div class="module-title">
                <span class="material-icons mr-2">{{ moduleIcon }}</span>
                {{ moduleName }}
            </div>
            <div class="d-flex align-items-center">
                <module-toggle
                    :is-active="isModuleFullySelected"
                    :is-partial="isModulePartiallySelected"
                    @toggle="toggleAll"
                />
                <span class="material-icons module-collapse-icon">{{ isExpanded ? 'expand_less' : 'expand_more' }}</span>
            </div>
        </button>
    </div>
</template>

<script>
import ModuleToggle from './ModuleToggle.vue';

export default {
    name: 'ModuleHeader',
    components: {
        ModuleToggle
    },
    props: {
        moduleName: {
            type: String,
            required: true
        },
        moduleIcon: {
            type: String,
            required: true
        },
        isModuleFullySelected: {
            type: Boolean,
            default: false
        },
        isModulePartiallySelected: {
            type: Boolean,
            default: false
        },
        isExpanded: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggleAccordion() {
            this.$emit('toggle-accordion');
        },
        toggleAll() {
            this.$emit('toggle-all');
        }
    }
}
</script>

<style lang="scss" scoped>
.module-header {
    .btn-light {
        background-color: #fff;
        border: none;
        padding: 0.8rem 1.2rem;
        border-radius: 0;
        border-bottom: 1px solid #f5f5f5;
        width: 100%;
        text-align: left;
        
        &:hover, &:focus {
            background-color: #f9f9f9;
        }
        
        &:active {
            background-color: #f5f5f5;
        }
    }
    
    .module-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        color: #333;
        font-size: 0.95rem;
        
        span {
            color: #4d7cfe;
            width: 22px;
            font-size: 1rem;
        }
    }
    
    .module-collapse-icon {
        color: #999;
        font-size: 0.9rem;
    }
}
</style> 